// Common styles
export const headerStyles = {
  container: 'border-b border-gray-200 dark:border-border-dark bg-white dark:bg-dark-background',
  logoButton: 'flex items-center space-x-3 hover:opacity-80 transition-opacity',
  logoTitle: 'text-xl font-semibold text-gray-900 dark:text-dark-text',
  avatarButton:
    'flex items-center justify-center transition-all duration-200 rounded-full bg-gradient-to-br from-primary to-primary-light ring-2 ring-white dark:ring-gray-800 hover:ring-primary/30 dark:hover:ring-primary-light/60',
  dropdown: 'absolute right-0 z-50 w-56 py-2 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-dark-background-secondary dark:border-border-dark',
  menuItem: 'w-full flex items-center px-4 py-2.5 text-sm transition-colors',
  menuItemActive: 'bg-primary/10 dark:bg-primary-light/40 text-primary dark:text-white',
  menuItemLogout: 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-rose-400/50',
  menuItemDefault: 'text-gray-700 dark:text-dark-text-secondary hover:bg-gray-100 dark:hover:bg-dark-background-hover',
  submenu: 'absolute top-0 z-50 w-48 py-2 bg-white border border-gray-200 rounded-lg shadow-lg right-full dark:bg-dark-background-secondary dark:border-border-dark'
};
